import { render, staticRenderFns } from "./HtCnOrderDetail.vue?vue&type=template&id=842336a2&scoped=true&"
import script from "./HtCnOrderDetail.vue?vue&type=script&lang=js&"
export * from "./HtCnOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./HtCnOrderDetail.vue?vue&type=style&index=0&id=842336a2&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "842336a2",
  null
  
)

export default component.exports